import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabelProps,
  InputBaseComponentProps,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import { RadioOption } from "./types";
import { useTranslation } from "react-i18next";

const RadioCst: React.FC<
  InputLabelProps &
    InputBaseComponentProps & {
      testIdPrefix?: string;
      ariaLabelOverride?: string;
    }
> = (props) => {
  const { t } = useTranslation(["input"]);

  const {
    id,
    label,
    value,
    placeholder = t("generic-placeholder") + label,
    onChange,
    options = [],
    customWidth,
    error = false,
    errorMessage = "",
    required = false,
    sx,
    testIdPrefix,
    ariaLabelOverride,
  } = props;

  const radioGroupId = testIdPrefix ? `${testIdPrefix}-input` : `radio-${id}`;
  const radioGroupTestId = testIdPrefix ? `${testIdPrefix}-input` : undefined;

  return (
    <FormControl
      error={error}
      size={"small"}
      required={required}
      sx={{
        minWidth: "200px",
        display: "flex",
        width: customWidth ? customWidth : "auto",
        ...sx,
      }}
    >
      <FormLabel
        id={`radio-${id}`}
        {...(testIdPrefix
          ? ({ "data-testid": `${testIdPrefix}-label` } as any)
          : {})}
      >
        {label}
      </FormLabel>
      <RadioGroup
        row
        value={value}
        id={radioGroupId}
        {...(radioGroupTestId
          ? ({ "data-testid": radioGroupTestId } as any)
          : {})}
        {...(ariaLabelOverride
          ? ({ "aria-label": ariaLabelOverride } as any)
          : { "aria-labelledby": `${label}-radio` })}
        onChange={(e: any) => {
          onChange && onChange(e.target.value);
        }}
      >
        {options.map(
          ({ label, value, disabled }: RadioOption, index: number) => {
            const optionAttrs = testIdPrefix
              ? ({
                  id: `${testIdPrefix}-option-${String(value).toLowerCase()}`,
                  "data-testid": `${testIdPrefix}-option-${String(
                    value,
                  ).toLowerCase()}`,
                } as any)
              : {};
            return (
              <FormControlLabel
                disabled={disabled}
                key={`radio-${index}`}
                value={value}
                control={<Radio />}
                label={label}
                {...optionAttrs}
              />
            );
          },
        )}
      </RadioGroup>
      <FormHelperText disabled={!error}>{error && errorMessage}</FormHelperText>
    </FormControl>
  );
};

export default RadioCst;
